const PageContainer = ({children,backgoundColor='#FFFFFF'})=>{
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column', /* 子元素垂直排列（自动换行） */
            width: '100%',
            minHeight: '100vh',
            backgroundColor:`${backgoundColor}`,
            paddingTop:'1px', //避免子元素margin塌陷
        }}>
            {children}
        </div>
    )
}

export default PageContainer;
